export default __webpack_public_path__ + "static/media/burn.c2b83745.svg";